import detect from '@/plugins/browserDetect'

import { fromDate } from '@/mixins/formatDateTime'

const UiLink = () => import('@/components/UiLink.vue')
const FilterColumnIcon = () => import('@/components/table/filters/FilterColumnIcon')
const CheckboxFilter = () => import('@/components/table/filters/Checkbox')
const RadioFilter = () => import('@/components/table/filters/Radio')
const RangeFilter = () => import('@/components/table/filters/Range')
const DateFilter = () => import('@/components/table/filters/Date')
const InputFilter = () => import('@/components/table/filters/Input')

const PLACEHOLDER = '—'

export default {
  computed: {
    isFirefox() {
      // Столбец domain должен быть зафиксирован при горизонтальном скролле.
      // Если столбец будет зафиксирован в Firefox, то выпадающий фильтр этого столбца будет обрезаться таблицей, когда записей в таблице мало или совсем нет.
      // Поэтому в Firefox просто не фиксируем столбец.

      // В Firefox выпадающий фильтр обрезается таблицей, т.к. у .ve-table-header-th css position = sticky
      // Фильтр не будет обрезаться таблицей, если у .ve-table-header-th css position = relative
      const browser = detect()

      return browser.name === 'firefox'
    },
    isFixedColumn() {
      return window.innerWidth > 768 && !this.isFirefox ? 'left' : null
    },
    columns() {
      return [
        {
          field: 'id',
          key: 'id',
          title: 'ID',
          align: 'right',
          sortBy: this.sortBy('id'),
          filterCustom: {
            render: ({ closeFn }) => (
              <RangeFilter closeFn={closeFn} title="ID:" queryKey="id_range" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['id_range']} />,
          },
        },
        {
          field: 'domain',
          key: 'domain',
          title: 'Application',
          align: 'left',
          fixed: this.isFixedColumn,
          sortBy: this.sortBy('domain'),
          renderBodyCell: ({ row }, h) => (
            <UiLink to={{ name: 'application', params: { id: row.id } }}> {row.domain} </UiLink>
          ),
          filterCustom: {
            render: ({ closeFn }) => (
              <InputFilter closeFn={closeFn} title="Application:" queryKey="domain" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['domain']} />,
          },
        },
        {
          field: 'balance',
          key: 'balance',
          title: 'Баланс, ₽',
          align: 'right',
          sortBy: this.sortBy('balance'),
          renderBodyCell: ({ row }) => row.balance || 0,
          filterCustom: {
            render: ({ closeFn }) => (
              <RangeFilter closeFn={closeFn} title="Баланс:" queryKey="balance_range" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['balance_range']} />,
          },
        },
        {
          field: 'days_left',
          key: 'days_left',
          title: 'Дней',
          align: 'right',
          sortBy: this.sortBy('days_left'),
          renderBodyCell: ({ row }) => row.days_left || 0,
          filterCustom: {
            render: ({ closeFn }) => (
              <RangeFilter closeFn={closeFn} title="Дней:" queryKey="days_range" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['days_range']} />,
          },
        },        
        {
          field: 'balanceBonus',
          key: 'balanceBonus',
          title: 'Бонус',
          align: 'right',
          sortBy: this.sortBy('balanceBonus'),
          renderBodyCell: ({ row }) => row.balanceBonus || 0,
          filterCustom: {
            render: ({ closeFn }) => (
              <RangeFilter closeFn={closeFn} title="Бонус:"  queryKey="bonus_range" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['bonus_range']} />,
          },
        },
        {
          field: 'cardCount',
          key: 'cardCount',
          title: 'Карт',
          align: 'right',
          sortBy: this.sortBy('cardCount'),
          renderBodyCell: ({ row }) => row.cardCount || 0,
          filterCustom: {
            render: ({ closeFn }) => (
              <RangeFilter closeFn={closeFn} title="Количество карт:" queryKey="cards_range" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['cards_range']} />,
          },
        },
        {
          field: 'tariff.name',
          key: 'tariffCode',
          title: 'Тариф CODE',
          align: 'left',
          renderBodyCell: ({ row }) => (row.tariff && row.tariff.name) || PLACEHOLDER,
          filterCustom: {
            render: ({ closeFn }) => {
              const tariffs = this.$store.getters['tariffs/code'].map((item) => {
                return { ...item }
              })

              return (
                <CheckboxFilter
                  closeFn={closeFn}
                  title="Тариф CODE:"
                  list={tariffs}
                  queryKey="tariffs_code"
                />
              )
            },
            filterIcon: () => <FilterColumnIcon queryKeys={['tariffs_code']} />,
          },
        },
        {
          field: 'tariffcard',
          key: 'tariffcard',
          title: 'Тариф CARD',
          align: 'left',
          width: 180,
          sortBy: this.sortBy('tariffcard'),
          renderBodyCell: ({ row }) => (row.tariffcard && row.tariffcard.name) || PLACEHOLDER,
          filterCustom: {
            render: ({ closeFn }) => {
              const tariffs = this.$store.getters['tariffs/card'].map((item) => {
                return { ...item }
              })

              return (
                <CheckboxFilter
                  closeFn={closeFn}
                  title="Тариф CARD:"
                  list={tariffs}
                  queryKey="tariffs_card"
                />
              )
            },
            filterIcon: () => <FilterColumnIcon queryKeys={['tariffs_card']} />,
          },
        },
        {
          field: 'last_payment_at',
          key: 'last_payment_at',
          title: 'Платеж',
          align: 'left',
          sortBy: this.sortBy('last_payment_at'),
          renderBodyCell: ({ row }) => {
            const result = row.last_payment_at ? fromDate(row.last_payment_at) : PLACEHOLDER
            return <div style="min-width: 100px">{result}</div>
          },
          filterCustom: {
            render: ({ closeFn }) => (
              <DateFilter closeFn={closeFn} title="Последний платеж:" queryKey="last_payment_at" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['last_payment_at']} />,
          },
        },
        {
          field: 'last_transaction_at',
          key: 'last_transaction_at',
          title: 'Транзакция',
          align: 'left',
          sortBy: this.sortBy('last_transaction_at'),
          renderBodyCell: ({ row }) => {
            const result = row.last_transaction_at ? fromDate(row.last_transaction_at) : PLACEHOLDER
            return <div style="min-width: 100px">{result}</div>
          },
          filterCustom: {
            render: ({ closeFn }) => (
              <DateFilter
                closeFn={closeFn}
                title="Последняя транзакция:"
                queryKey="last_transaction_at"
              />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['last_transaction_at']} />,
          },
        },
        {
          field: 'last_card_at',
          key: 'last_card_at',
          title: 'Карта',
          align: 'left',
          sortBy: this.sortBy('last_card_at'),
          renderBodyCell: ({ row }) => {
            const result = row.last_card_at ? fromDate(row.last_card_at) : PLACEHOLDER
            return <div style="min-width: 100px">{result}</div>
          },
          filterCustom: {
            render: ({ closeFn }) => (
              <DateFilter closeFn={closeFn} title="Последняя карта:" queryKey="last_card_at" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['last_card_at']} />,
          },
        },
        {
          field: 'created_at',
          key: 'created_at',
          title: 'Регистрация',
          align: 'left',
          sortBy: this.sortBy('created_at'),
          renderBodyCell: ({ row }) => {
            const result = row.created_at ? fromDate(row.created_at) : PLACEHOLDER
            return <div style="min-width: 100px">{result}</div>
          },
          filterCustom: {
            render: ({ closeFn }) => (
              <DateFilter closeFn={closeFn} title="Регистрация аккаунта" queryKey="created_at" />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['created_at']} />,
          },
        },
        {
          field: 'update_date',
          key: 'update_date',
          title: 'Дата обновления',
          align: 'left',
          renderBodyCell: ({ row }) => {
            const result = row.updated_at ? fromDate(row.updated_at) : PLACEHOLDER
            return <div style="min-width: 100px">{result}</div>
          },
        },
        {
          field: 'is_demo',
          key: 'is_demo',
          title: 'Демо',
          align: 'left',
          renderBodyCell: ({ row }) => {
            const isDemo = row.slots && row.slots.is_demo

            if (isDemo === 1) return 'Да'
            else return 'Нет'
          },
        },
        {
          field: 'agent_type',
          key: 'agent_type',
          title: 'Тип агента',
          align: 'left',
          renderBodyCell: ({ row }) => {
            if (!row.agent_info) return PLACEHOLDER

            const rate = row.agent_info.rate
            const promo = row.agent_info.promo
            return (
              <div style="min-width: 140px">
                {rate}%, {promo}
              </div>
            )
          },
        },
        {
          field: 'agentId',
          key: 'agentId',
          title: 'Parent ID',
          align: 'left',
        },
        {
          field: 'apple_team',
          key: 'apple_team',
          title: 'Apple Team',
          align: 'left',
          renderBodyCell: ({ row }) => (row.pass_type_id && row.pass_type_id.team) || PLACEHOLDER,
          filterCustom: {
            render: ({ closeFn }) => {
              return (
                <div>
                  <RadioFilter
                    title="Apple Team:"
                    closeFn={closeFn}
                    list={[
                      { value: '0', label: 'Нет' },
                      { value: '1', label: 'Наш' },
                      { value: '2', label: 'Свой' },
                    ]}
                    queryKey="apple_team"
                  />
                </div>
              )
            },
            filterIcon: () => <FilterColumnIcon queryKeys={['our_cert', 'apple_team']} />,
          },
        },
        {
          field: 'expired_at',
          key: 'expired_at',
          title: 'Окончание Apple',
          align: 'left',
          sortBy: this.sortBy('expired_at'),
          renderBodyCell: ({ row }) => {
            if (!row.pass_type_id) return PLACEHOLDER

            const result = fromDate(row.pass_type_id.expired_at)
            return <div style="min-width: 100px">{result}</div>
          },
        },
        {
          field: 'googlePay',
          key: 'googlePay',
          title: 'Google Pay',
          align: 'left',
          renderBodyCell: ({ row }) => (row.google_pay && row.google_pay.issuerId) || PLACEHOLDER,
          filterCustom: {
            render: ({ closeFn }) => (
              <RadioFilter
                closeFn={closeFn}
                title="Google Pay:"
                list={[
                  { value: '1', label: 'Подключен' },
                  { value: '0', label: 'Не подключен' },
                ]}
                queryKey="google_pay"
              />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['google_pay']} />,
          },
        },
        {
          field: 'polls',
          key: 'polls',
          title: 'Анкета',
          align: 'left',
          renderBodyCell: ({ row }) => (row.polls ? 'Есть' : 'Нет'),
          filterCustom: {
            render: ({ closeFn }) => (
              <RadioFilter
                closeFn={closeFn}
                title="Анкета:"
                list={[
                  { value: '1', label: 'Есть' },
                  { value: '0', label: 'Нет' },
                ]}
                queryKey="polls"
              />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['polls']} />,
          },
        },
        {
          field: 'utm_source',
          key: 'utm_source',
          title: 'utm_source',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return <div style="white-space: nowrap">{row.utm_source || PLACEHOLDER}</div>
          },
          filterCustom: {
            render: ({ closeFn }) => (
              <RadioFilter
                closeFn={closeFn}
                title="Utm source:"
                list={[
                  { value: '1', label: 'Есть' },
                  { value: '0', label: 'Нет' },
                ]}
                queryKey="utm_source"
              />
            ),
            filterIcon: () => <FilterColumnIcon queryKeys={['utm_source']} />,
          },
        },
        {
          field: 'utm_medium',
          key: 'utm_medium',
          title: 'utm_medium',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return <div style="white-space: nowrap">{row.utm_medium || PLACEHOLDER}</div>
          },
        },
        {
          field: 'utm_campaign',
          key: 'utm_campaign',
          title: 'utm_campaign',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return <div style="white-space: nowrap">{row.utm_campaign || PLACEHOLDER}</div>
          },
        },
        {
          field: 'utm_content',
          key: 'utm_content',
          title: 'utm_content',
          align: 'left',
          renderBodyCell: ({ row }) => {
            const value = row.utm_content || PLACEHOLDER
            return (
              <div
                style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                title={value}
              >
                {value}
              </div>
            )
          },
        },
        {
          field: 'utm_term',
          key: 'utm_term',
          title: 'utm_term',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return <div style="white-space: nowrap">{row.utm_term || PLACEHOLDER}</div>
          },
        },
      ]
    },
  },
}
